import styled from 'styled-components';

interface TextProps {
  color?: string;
  fontWeight?: string | number;
  fontSize?: string | number;
}
export const Content = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  min-width: 60px;
  width: 70px;
  justify-content: space-between;
`;
export const Text = styled.div<TextProps>`
  width: 70%;
  text-align: right;
  color: ${({ color }) => color};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
